import { alpha, styled } from "@mui/material";

export const DropOverlay = styled("div")(({ theme }) => ({
  display: "none",
  visibility: "hidden",
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  backgroundColor: alpha(theme.palette.info.light, 0.1),
  outline: `2px dashed ${theme.palette.info.light}`,
  borderRadius: `${theme.shape.borderRadius}px !important`,
  zIndex: 900,
}));

export const ProgressDropOverlay = styled(DropOverlay)(() => ({
  display: "block",
  visibility: "visible",
  animation: "1s ease-in-out 0.5s infinite normal none bottomToolbarPulsing",
  "@keyframes bottomToolbarPulsing": {
    "0%": {
      opacity: 1,
    },
    "50%": {
      opacity: 0.4,
    },
    "100%": {
      opacity: 1,
    },
  },
}));
